import SalesAndDeals from "../../Components/SalesAndDeals/SalesAndDeals";


function SalesAndDealsPage() {
  return <SalesAndDeals />;
}

export default SalesAndDealsPage;